import React, { useEffect, useRef } from "react";
import { useSearchParams, useSubmit, useParams, redirect } from "react-router";
import axios from "axios";
import { renderSavingProgressToast } from "components/shared/Toasts";
import { SubscriptionCheckoutCallbackSchema } from "schema/subscription";
import { getPlatformShortName } from "utils/CapacitorUtil";

export async function action({ request }) {
    const updates = await request.json();
    var result = await renderSavingProgressToast(
        axios.post(
            "subscription/paypal/callback",
            SubscriptionCheckoutCallbackSchema.cast(updates)
        )
    )
        .then(() => ({ success: true }))
        .catch((error) => {
            if (error.response?.data) {
                var data = error.response?.data;
                return Promise.resolve({
                    success: false,
                    reason: data["description"],
                });
            }
            return Promise.reject(error);
        });
    if (result.success) {
        const platform = getPlatformShortName();
        return redirect(`/subscription/${platform}/paypal/checkout-success`);
    }
    return result;
}

const CheckoutCallback = () => {
    const params = useParams();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const hasSubmitted = useRef(false);

    useEffect(() => {
        if (hasSubmitted.current) return;

        const state = searchParams.get("state");
        const subscriptionId = searchParams.get("subscription_id");
        const platform = getPlatformShortName();

        if (state && subscriptionId) {
            hasSubmitted.current = true;
            submit(
                {
                    state,
                    subscription_id: subscriptionId,
                },
                {
                    action: `/subscription/${platform}/${params.provider}/checkout-callback`,
                    method: "post",
                    encType: "application/json",
                }
            );
        } else {
            console.error("Failed to send callback");
        }
    }, [searchParams, submit, params.provider]);

    return <div>Updating subscription...</div>;
};

export default CheckoutCallback;
